import { LogoIcon } from "../images/LogoIcon";

export const Logo = () => {
  return <LogoIcon />;
};
